import { getUsers, isUsersFetching } from "reducers";
import PropTypes from "prop-types";
import {
  USER_FETCH_ACTION_CREATORS,
  ONBOARDINGCOACHES,  
  exportUserTable
} from 'actions/users'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import DataColumnFilterTable from 'components/ui/data-column-filter-table'
import { InlineWaiting, PageHeader } from 'components/ui'
import capitalize from 'lodash/capitalize'
import { FaGlobe } from "react-icons/lib/fa";

const [fetchUsers, invalidateUsers] = USER_FETCH_ACTION_CREATORS[ONBOARDINGCOACHES]
class MultiFilterOnboardingCoachTable extends Component {
  
  componentDidMount() {
    this.handleRefresh();
  }
 
  handleRefresh = () => {
    const { dispatch } = this.props
    dispatch(invalidateUsers())
    dispatch(fetchUsers())
  }

  handleExport = (filteredRows) => {
    this.props.dispatch(exportUserTable('onboarding_coaches', filteredRows))
  }

  render() {
    const {
      users,      
      isFetching
    } = this.props
    const nameSort = ({name}) => capitalize(name)

    return (
      <div>
        <PageHeader
        title= "Onboarding Coaches"
        />
        <DataColumnFilterTable
          columns={[
            {
              title: 'Sort by name',
              header: 'Name',
              field: user => user.name,
              format: user => (
                <Link to={`/users/${user.id}`}>                
                  {user.name} {user.contracted_employee ? <FaGlobe /> : ""}
                </Link>
              ),
            
              filterTest: 'name'
            },
            {
              title: "Sort by Email",
              header: "Email",
              field: user => user.email
            },
            {
                title: 'Sort by Company',
                header: 'Company',
                field: user => (
                  <Link to={`/companies/${user.company.key}/profile`}>                
                    {user.company.value}
                  </Link>)
            },
            {
              title: "Sort by Assigned Team",
              header: "Team",
              field: user => user.team.value
            },
            {
              title: "Sort by Active Patients",
              header: "Active Patients",
              field: user => user.active_patients
            },
            {
              title: "Sort by User Type",
              header: "User Type",
              field: user => user.role
            },
            { 
              title: 'Sort by Active',
              header: 'Active',
              field: user => user.active.toString(),
              boolean: true
            }           
          ]}
          rows={users}
          onRefresh = {this.handleRefresh}
          onExport= {this.handleExport}
          initialSort={{ iteratee: nameSort }}
          initialFilters={[{
            input: '',
            columnIndex: 6,
            testOpKey: 'REG_EXP',
            selectActiveBoolean: 'true'
          }]} />
        {isFetching && <InlineWaiting reason='Fetching Onboarding Coaches...' />}
      </div>
    )
  }
}

export default connect(state => ({
  users: getUsers(state, ONBOARDINGCOACHES),
  isFetching: isUsersFetching(state, ONBOARDINGCOACHES)
}))(MultiFilterOnboardingCoachTable)

MultiFilterOnboardingCoachTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFetching: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};
